export default function sortByProperty<T>(list: T[], prop: keyof T): T[] {
  return [...list].sort((a, b) => {
    if (a[prop] && !b[prop]) {
      return -1;
    }

    if (!a[prop] && b[prop]) {
      return 1;
    }

    return 0;
  });
}
